import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import BankFindLocations from "../components/BankFind/BankFindLocations";
import { All, KeyValue } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (field: string, value: string) => {
      dispatch(actions.updateFilter(field, value));
    },
    updateUI: (field: string, value: string) => {
      dispatch(actions.updateUi(field, value));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BankFindLocations);
